import { CustomerService } from './customer.service';
import { NgModule } from '@angular/core';
import { CustomerBackend } from './customer.backend';

@NgModule({
  providers: [CustomerService, CustomerBackend],
})
export class CustomerModule {}
